import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GetPublicityService {
  url: string = environment.url;
  constructor(private http: HttpClient) {}
  typeFile: any[] = [];
  
  getPublicityTypes(type, pos, userId = '/') {
    return this.http.get(`${this.url}/publicity/index/${type}/${pos}/${userId}`);
  }
}
